"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _button = _interopRequireDefault(require("../Button/button"));

var _icon = _interopRequireDefault(require("../Icon/icon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var COPY = 'Copy';
var SUCCESS_DELAY = 1500;
var HIDDEN = {
  boxSizing: 'content-box'
};

var CopyToClipboardButton =
/*#__PURE__*/
function (_React$Component) {
  _inherits(CopyToClipboardButton, _React$Component);

  function CopyToClipboardButton(props) {
    var _this;

    _classCallCheck(this, CopyToClipboardButton);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(CopyToClipboardButton).call(this, props));
    _this.state = {
      buttonState: null
    };
    _this.copyInput = null;
    _this.copyToClipboard = _this.copyToClipboard.bind(_assertThisInitialized(_this));
    _this.handleOnClick = _this.handleOnClick.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(CopyToClipboardButton, [{
    key: "copyToClipboard",
    value: function copyToClipboard() {
      var _this$props = this.props,
          text = _this$props.text,
          onCopy = _this$props.onCopy;
      this.copyInput.select();
      document.execCommand('copy');
      onCopy(text);
    }
  }, {
    key: "handleOnClick",
    value: function handleOnClick() {
      var _this2 = this;

      this.copyToClipboard();
      this.setState({
        buttonState: _button.default.SUCCESS_STATE
      });
      setTimeout(function () {
        return _this2.setState({
          buttonState: null
        });
      }, SUCCESS_DELAY);
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props2 = this.props,
          text = _this$props2.text,
          children = _this$props2.children;
      var buttonState = this.state.buttonState;

      var content = children || _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_icon.default, {
        name: _icon.default.COPY,
        small: true
      }), _react.default.createElement("span", null, COPY));

      return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_button.default, {
        asLink: true,
        primary: true,
        state: buttonState,
        onClick: this.handleOnClick
      }, content), _react.default.createElement("input", {
        readOnly: true,
        type: "text",
        value: text,
        className: "co--visually-hidden",
        style: HIDDEN,
        ref: function ref(input) {
          _this3.copyInput = input;
        }
      }));
    }
  }]);

  return CopyToClipboardButton;
}(_react.default.Component);

CopyToClipboardButton.defaultProps = {
  onCopy: function onCopy() {}
};
CopyToClipboardButton.propTypes = {
  text: _propTypes.default.string.isRequired,
  onCopy: _propTypes.default.func
};
var _default = CopyToClipboardButton;
exports.default = _default;
CopyToClipboardButton.__docgenInfo = {
  "description": "",
  "methods": [{
    "name": "copyToClipboard",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "handleOnClick",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }],
  "displayName": "CopyToClipboardButton",
  "props": {
    "onCopy": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "text": {
      "type": {
        "name": "string"
      },
      "required": true,
      "description": ""
    }
  }
};